import { Box, Grid, Typography } from '@mui/material';
import FormGridItem from '~/components/FormComponents/FormGridItem.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { Bookmark } from '@mui/icons-material';
import { commonStyles } from '~/theme/styles/commonStyles.ts';
import { InfoTooltip } from '~/components/InfoTooltip/InfoTooltip.tsx';
import { informerCountryEng } from '~/modules/identification/forms/FatcaAdditionalInformation/constants/informers.tsx';
import { styles } from '~/modules/identification/styles.ts';

interface ISubstantialUSOwnersProps {
  index: number;
}

export const SubstantialUSOwners = ({ index }: ISubstantialUSOwnersProps) => {
  const basePath = `nffeInfo.substantialUSOwners.${index}`;

  return (
    <Box sx={styles.border}>
      <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
        <Typography variant="h6">Власник {index + 1}</Typography>
        <Bookmark color="primary" sx={{ height: 30, width: 30 }} />
      </Grid>
      <Grid container spacing={3}>
        <FormGridItem>
          <FormInput
            name={`${basePath}.lastName`}
            label="Прізвище"
            placeholder="Введіть прізвище"
            disabled
            fullWidth
          />
        </FormGridItem>
        <FormGridItem>
          <FormInput
            name={`${basePath}.firstName`}
            label="Ім’я"
            placeholder="Введіть ім’я"
            disabled
            fullWidth
          />
        </FormGridItem>
        <FormGridItem>
          <FormInput
            name={`${basePath}.middleName`}
            label="По батькові"
            placeholder="Введіть по батькові"
            disabled
            fullWidth
          />
        </FormGridItem>
        <Box sx={{ width: '100%' }}>
          <Typography variant="h6" sx={styles.titleForm}>
            Заповніть, будь ласка, інформацію щодо контролюючої особи / власника істотної участі
            (10% і більше) англійською мовою:
          </Typography>
        </Box>
        <FormGridItem>
          <FormInput
            name={`${basePath}.lastNameEng`}
            label="Прізвище (англійською мовою)"
            placeholder="Введіть прізвище (англійською мовою)"
            fullWidth
          />
        </FormGridItem>
        <FormGridItem>
          <FormInput
            name={`${basePath}.firstNameEng`}
            label="Ім'я (англійською мовою)"
            placeholder="Введіть ім'я (англійською мовою)"
            fullWidth
          />
        </FormGridItem>
        <FormGridItem>
          <FormInput
            name={`${basePath}.middleNameEng`}
            label="По батькові (англійською мовою)"
            placeholder="Введіть по батькові (англійською мовою)"
            fullWidth
          />
        </FormGridItem>
        <FormGridItem>
          <FormInput
            name={`${basePath}.tin`}
            label="Ідентифікаційний номер платника податків США (TIN (SSN, ITIN))"
            placeholder="Введіть ідентифікаційний номер платника податків США (TIN (SSN, ITIN))"
            fullWidth
          />
        </FormGridItem>
        <FormGridItem>
          <FormInput
            name={`${basePath}.countryEng`}
            label={
              <Box sx={{ ...commonStyles.centerFlexContainer, gap: 1 }}>
                <Typography variant="body2">Країна (англійською мовою)</Typography>
                <InfoTooltip title={informerCountryEng} />
              </Box>
            }
            placeholder="Введіть назву країна (англійською мовою)"
            fullWidth
          />
        </FormGridItem>
        <FormGridItem>
          <FormInput
            name={`${basePath}.cityEng`}
            label={
              <Box sx={{ ...commonStyles.centerFlexContainer, gap: 1 }}>
                <Typography variant="body2">
                  Місто або населений пункт (англійською мовою)
                </Typography>
                <InfoTooltip title={informerCountryEng} />
              </Box>
            }
            placeholder="Введіть назву міста або населеного пункту (англійською мовою)"
            fullWidth
          />
        </FormGridItem>
      </Grid>
    </Box>
  );
};
